import { createContext } from 'react';

type Highlight = { highlight: boolean; match: string };

const HighlightContext = createContext<Highlight>({
  highlight: false,
  match: '',
});

export { HighlightContext };
